import Tabs from '../lib/tabs';

const tabs = () => {
  // tabs
  const tabs = document.querySelectorAll('[id^=tabs_]');

  if(tabs === 0 ) {
    return;
  } else {
    tabs.forEach((tab) => {
      let openIndex = 0;

      if(tab.getAttribute('tab-index')) {
        openIndex = tab.getAttribute('tab-index');
      }

      new Tabs ({
        elem: tab.id,
        open: parseInt(openIndex)
      });
    });
  }

}

export default tabs;
